import { useState } from "react";
import { createPerson } from "../service/personService";
import { Person } from "../types";

// The backend sends validation/conflict reasons as a plain-text body.
const messageOf = (err: any): string => {
  const data = err?.response?.data;
  return typeof data === "string" && data.trim() ? data : "Failed to create person.";
};

export function useCreatePerson() {
  const [saving, setSaving] = useState(false);

  /** Returns null on success, or the reason it failed. */
  async function create(data: Person): Promise<string | null> {
    setSaving(true);
    try {
      await createPerson(data);
      return null;
    } catch (err) {
      return messageOf(err);
    } finally {
      setSaving(false);
    }
  }

  return { create, saving };
}
